import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { DropdownMenu } from 'src/app/models/app/dropdown-menu.model';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PageService } from 'src/app/services/page/page.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  imports: [CommonModule, RouterModule],
})
export class SidebarComponent implements OnInit {
  dropDown = false;
  sideOpen!: boolean;
  questionDropwdown!: DropdownMenu[];
  dropSub!: Subscription;
  surveyPageSub!: Subscription;
  isAuthenticated: boolean = false;
  user!: string;
  pageNav = this.dropService.pageNav;
  surveyPage = false;

  constructor(
    private dropService: DropdownService,
    private ref: ChangeDetectorRef,
    private authService: AuthService,
    private pageService: PageService,
  ) { }

  ngOnInit() {
    this.dropSub = this.dropService.open.subscribe((res) => {
      this.sideOpen = res;
    });

    //get dropdown list
    this.dropService.surveyNavigationList.subscribe((surveyNavigationList) => {
      this.questionDropwdown = surveyNavigationList;
    });

    // Subscribe to surveyPage state
    this.surveyPageSub = this.dropService.surveyPage.subscribe((res) => {
      this.surveyPage = res;
    });

    this.callCheckStatus();
  }

  dropDownClick() {
    this.dropDown = !this.dropDown;
  }

  linkClick() {
    this.dropDown = false;
  }
  ngOnDestroy() {
    this.dropSub.unsubscribe();
    this.surveyPageSub.unsubscribe();
  }

  callCheckStatus(): void {
    this.authService.checkStatus().subscribe((loginResponseData) => {
      if (!loginResponseData.username) {
        this.isAuthenticated = false;
      } else {
        this.user = loginResponseData.username;
        this.isAuthenticated = true;
      }

      //get page status info, only if authenticated
      if (this.isAuthenticated) {
        // Add 500ms delay before first call to make sure any new survey generated from checking auth status is generated
        setTimeout(() => {
          this.dropService.setPageCompletionStatuses();

          // Recall after 2 seconds - just in case - shouldn't hurt - can we make this process better with signals or maybe different workflow in the API?
          setTimeout(() => {
            this.dropService.setPageCompletionStatuses();
          }, 2000);
        }, 500);
      }
    });
  }
}
